import * as React from "react";
import { useState, useRef, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getWorkkardSearchList,fetchUserRecentSearches,removeRecentSearchItem,resetSearchSuggestion,
    addglobalsearchusage,resetGlobalSearch,saveSearchString } from '../actions/action';
import { showDialogueBox,hideDialogueBox } from '../../../components/DialogueBox/actions';
import LoaderComponent from '../../../components/Loader';
import { debounce } from 'lodash';
import Icon from '../../../icons';
import ExpandedGlobalSearch from "./expandedSearch";
import * as HeaderUtil from '../Notification/utils';
import { isMobile, mobileAndTabletcheck } from "../../../common/util";
import { useModules } from "../../../utils/modules";

export function GlobalSearch(props) {
  const {
    globalSearch,
    dialogueBox,
    sessionContext,
    changeShowResult,
    searchExpandedRef,
    fetchUserRecentSearches,
    getWorkkardSearchList,
    resetSearchSuggestion,
    addglobalsearchusage,
    resetGlobalSearch,
    showDialogueBox,
    hideDialogueBox,
    saveSearchString,
  } = props;

  const [searchText, setSearchText] = useState("");
  const [showResult, setShowResult] = useState(false);
  const [selectedItem, setSelectedItem] = useState(-1);
  const [upDownPressed, setUpDownPressed] = useState(false);
  const [isLandscape, setIsLandscape] = useState(false);
  const [recentSelectedItem, setRecentSelectedItem] = useState("");

  const searchRef = useRef(null);
  const isEnterToSearchEnabled = useModules().isModuleEnabled("top_bar_search.enter_to_search");

  // debounced function created once,
  // always dispatching against the latest state/props via the ref indirection below
  const handleGlobalSearchRef = useRef();
  handleGlobalSearchRef.current = () => {
    //when user enters 3 search characters handle
    const query = searchText;
    if (query.trim().length >= 3) {
      const payload = {
        q: query,
        _: new Date(),
      };
      getWorkkardSearchList(payload); //action fucntion to get the suggestions
      if (!dialogueBox.flag) {
        saveSearchString({ string: query }); // action function to save search string in redux
      }
    }
  };
  const handleGlobalSearch = useRef(
    debounce(() => handleGlobalSearchRef.current(), 200)
  ).current;

  // mousedown listener once on mount
  const handleOutsideClickRef = useRef();
  handleOutsideClickRef.current = (event) => {
    if (showResult) {
      if (dialogueBox.flag && ! mobileAndTabletcheck()) {
        // outside click handler  
        if (
          searchExpandedRef &&
          !searchExpandedRef.contains(event.target)
        ) {
          onCloseResult();
        }
      } else {
        if (searchRef.current && !searchRef.current.contains(event.target)) {
          onCloseResult();
          if ( mobileAndTabletcheck()) {
              document.getElementById("txtGlobalSearchinput").style.display = "none";
              $("#globalSearchdiv").removeClass("active");
              document.querySelector("#chevIcon").style.display = "none";
          }
        }
      }
    }
  };

  useEffect(() => {
    const listener = (event) => handleOutsideClickRef.current(event);
    document.addEventListener("mousedown", listener);
    const payload = {};
    if (useModules().isModuleEnabled("top_bar_search.search_history")) {
      fetchUserRecentSearches(payload); //action function to fetch recent searches
    }
    if (props.searchText) {
      //this condition is added when global search component is called from expanded search
      setSearchText(props.searchText);
    }
    if (
       mobileAndTabletcheck() &&
      window.innerHeight < window.innerWidth
    ) {
      setIsLandscape(true);
    }
    return () => {
      document.removeEventListener("mousedown", listener);
    };
  }, []);

  const onChangeSearchText = (e) => {
    //function called on every input in search box
    const newSearchText = e.target.value;
    setSearchText(newSearchText);
    setRecentSelectedItem("");
    if (
      newSearchText.trim().length == 0 &&
      globalSearch.recentSearches.length == 0
    ) {
      setShowResult(false);
      if (! mobileAndTabletcheck()) {
        if (changeShowResult) {
          changeShowResult(false);
        }
        if (dialogueBox.flag) {
          //active class handle for global search div
          $("#globalSearchdivExpandedView").removeClass("active");
        } else {
          $("#globalSearchdiv").removeClass("active");
        }
      }
    } else if (!showResult) {
      setShowResult(true);
      if (changeShowResult) {
        changeShowResult(true);
      }
      if (dialogueBox.flag) {
        //active class handle for global search div
        $("#globalSearchdivExpandedView").addClass("active");
      } else {
        $("#globalSearchdiv").addClass("active");
      }
    }
  };

  const onCloseResult = () => {
    setShowResult(false);
    setUpDownPressed(false);
    setRecentSelectedItem("");
    setSelectedItem(-1);
    if (changeShowResult) {
      changeShowResult(false);
    }
    if (! mobileAndTabletcheck()) {
      //active class handle of expanded search for mobile view
      $("#globalSearchdiv").removeClass("active hover");
      $("#globalSearchdivExpandedView").removeClass("active hover");
    }
  };

  const removeRecentSearchItem = (e, itemId, isClearAll) => {
    // remove recent search
    e.stopPropagation();
    const payload = {
      wkid: itemId,
      isClearAll: isClearAll,
    };

    props.removeRecentSearchItem(payload);
    if (isClearAll) {
      //on clear all remove the active class from gloabl search div handle
      setShowResult(false);
      if (dialogueBox.flag) {
        $("#globalSearchdivExpandedView").removeClass("active");
      } else {
        $("#globalSearchdiv").removeClass("active");
        { mobileAndTabletcheck() && $("#txtGlobalSearchinput").hide()}
      }
    }
  };

  const handleSuggestionClick = (data) => {
    //function to add recent searches in DB & add global search usage
    if (data) {
      const payload = {
        IsAutoSuggest: true,
        wkId: data.WorkkardId || 0,
        wkNumber: data.WorkkardNumber || "",
        wkDesc: data.WkDescription || data.WorkkardDesc || "",
        wkName: data.WorkkardNameForClaimWk || data.WorkkardOwner || "",
        wkStatus: "",
        search_data: JSON.stringify(data)

      };
      addglobalsearchusage(payload);
    }
    if ( mobileAndTabletcheck()) {
      setSearchText("");
      document.getElementById("txtGlobalSearchinput").style.display =
        "none";
      document.querySelector("#chevIcon").style.display = "none";
    }
  };

  const upDownArrowKeyHandler = (keyCode) => {
    let listSize = 0,
      list = [],
      selector = "";
    if (globalSearch.suggestion.length > 0) {
      listSize = globalSearch.suggestion.length;
      list = globalSearch.suggestion;
      selector = ".workkardIitems";
    } else {
      listSize = globalSearch.recentSearches.slice(0, 5).length;
      list = globalSearch.recentSearches.slice(0, 5);
      selector = ".recentSearchResult";
    }
    let newSelected;
    if (selectedItem === -1) {
      newSelected = 0;
    } else if (keyCode == 38) {
      newSelected =
        selectedItem === 0
          ? listSize - 1
          : selectedItem - 1;
    } else if (keyCode === 40) {
      newSelected = (selectedItem + 1) % listSize;
    }
    // guard against for a stale selection
    if (!list[newSelected]) {
      return;
    }
    setSelectedItem(newSelected);
    setUpDownPressed(true);
    if (globalSearch.suggestion.length > 0) {
      setSearchText(list[newSelected].WorkkardNumber);
    } else {
      setRecentSelectedItem(list[newSelected].WorkkardNumber);
    }
    const Id = list[newSelected].WorkkardId;
    const selectedEl = document.getElementById(Id);
    if (!selectedEl) {
      return;
    }
    // special case of beginning and end
    if (newSelected === listSize - 1) {
      selectedEl.scrollIntoView();
      return;
    } else if (newSelected === 0) {
      document.querySelector(selector).scrollTo(0, 0);
      return;
    }
    const scrollTop = document.querySelector(selector).scrollTop;
    const selectedElementTop = selectedEl.offsetTop;
    const selectedElementHeight = selectedEl.offsetHeight;
    const scrollWindowHeight = document.querySelector(selector).offsetHeight;
    // no scroll if selected element top position and bottom position is inside the scroll window
    if (
      selectedElementTop > scrollTop + 80 &&
      selectedElementTop + selectedElementHeight <
      scrollTop + scrollWindowHeight
    ) {
      return;
    }
    // scroll upward or downward by the selected element height if selected element top position or bottom position is outside the scroll window
    if (keyCode == 38) {
      document.querySelector(selector).scrollBy(0, -selectedElementHeight);
    } else if (keyCode === 40) {
      document.querySelector(selector).scrollBy(0, selectedElementHeight);
    }
  };

  const handleKeyDown = (e) => {
    let listSize = 0;
    if (searchText.trim().length > 0) {
      listSize = globalSearch.suggestion.length;
    } else {
      listSize = globalSearch.recentSearches.slice(0, 5).length;
    }
    if (e.keyCode == 13) {
      if (!isEnterToSearchEnabled && !upDownPressed) return;
      if (searchText.trim().length > 0 || recentSelectedItem.trim().length > 0) {
        // enter key handler when text box active
        setShowResult(false);
        setUpDownPressed(false);
        setSelectedItem(-1);
        if (listSize === 1) {
          // enter key handler when search result is only one
          const workkard =
            recentSelectedItem.trim().length == 0
              ? globalSearch.suggestion[0]
              : globalSearch.recentSearches[0];
          handleSuggestionClick(workkard);
          $("#globalSearchdiv").removeClass("active");
          window.location = `/getclmdetail?cId=${workkard.WorkkardId}`;
          return;
        } else {
          if (dialogueBox.flag ) {
            if(!isMobile()) {
              $("#globalSearchdivExpandedView").removeClass("active");
              let globaDiv = document.querySelector(
                "#globalSearchdivExpandedView"
              );
              globaDiv.querySelector("#txtGlobalSearchinput").blur();
              changeShowResult(false, true);

            }

            saveSearchString({ string: searchText });
          } else {
            const selectedWorkkard =
              recentSelectedItem.trim().length == 0
                ? globalSearch.suggestion[selectedItem]
                : globalSearch.recentSearches[selectedItem];
            if (
              upDownPressed &&
              selectedWorkkard &&
              (searchText.trim().length > 0 ||
                recentSelectedItem.trim().length > 0) &&
              selectedWorkkard.WorkkardNumber.startsWith(searchText)
            ) {
              $("#globalSearchdiv").removeClass("active");
              window.location = `/getclmdetail?cId=${selectedWorkkard.WorkkardId}`;
              handleSuggestionClick(selectedWorkkard);
              return;
            }
            // open ExpandedGlobalSearch pop up if not redirected
            if (useModules().isModuleEnabled("top_bar_search.search_result")) {
              showDialogueBox({
                flag: true,
                component: (
                  <ExpandedGlobalSearch
                    sessionContext={sessionContext}
                    searchString={searchText}
                    onClose={() => handleDialogueBoxClose()}
                  />
                ),
                overlayClassName: "modal animated faster fadeIn",
                contentClassName:
                  "modalContent globalSearchModalContent modalFixed animated faster fadeInUpx2 medium",
                shouldCloseOnOverlayClick: true,
              });
            }
          }
        }
      }
    } else if (listSize > 0 && (e.keyCode === 38 || e.keyCode === 40)) {
      // updown arrow key handler when search results are present
      if (e.currentTarget && e.currentTarget.id == "txtGlobalSearchinput")
        upDownArrowKeyHandler(e.keyCode);
    } else if (e.keyCode === 27) {
      // escape key handler when text box active
      setShowResult(false);
      setUpDownPressed(false);
      setSelectedItem(-1);
      $("#globalSearchdiv").removeClass("active");
      $("#globalSearchdivExpandedView").removeClass("active");
      if ( mobileAndTabletcheck()) {
        setSearchText("");
        document.getElementById("txtGlobalSearchinput").style.display =
          "none";
        document.querySelector("#chevIcon").style.display = "none";
      }
    } else if (e.isViewAll) {
      //When view all is click from dropdown
      setShowResult(false);
      setUpDownPressed(false);
      setSelectedItem(-1);
      if (!useModules().isModuleEnabled("top_bar_search.search_result")) return;
      showDialogueBox({
        flag: true,
        component: (
          <ExpandedGlobalSearch
            sessionContext={sessionContext}
            searchString={searchText}
            onClose={() => handleDialogueBoxClose()}
          />
        ),
        overlayClassName: "modal animated faster fadeIn",
        contentClassName:
          "modalContent globalSearchModalContent modalFixed animated faster fadeInUpx2 medium",
        shouldCloseOnOverlayClick: true,
      });
    }
  };

  const handleDialogueBoxClose = () => {
    hideDialogueBox();
    resetGlobalSearch();
    setSearchText("");
    setShowResult(false);
    $("#globalSearchdiv").removeClass("active");
    if ( mobileAndTabletcheck()) {
      //on mobile back icon , clear icon display handle. With active class handle of input field
      document.querySelector("#chevIcon").style.display = "none";
      document.querySelector("#clearSearchIcon").style.display = "none";
      document.getElementById("txtGlobalSearchinput").style.display = "none";
      $("#globalSearchdivExpandedView").removeClass("active");
    }
  };

  const handleMobileSearchIconClick = () => {
    //on mobile search icon click
    if (searchText.trim().length != 0 && showResult) {
      if (!isEnterToSearchEnabled) return;
      if (dialogueBox.flag) {
        saveSearchString({ string: searchText });
        setShowResult(false);
        changeShowResult(false);
      } else {
        if (searchText.trim().length > 0) {
          handleKeyDown({ isViewAll: true });
        }
      }
    } else {
      document.getElementById("txtGlobalSearchinput").style.display = "flex";
      $("#globalSearchdiv").addClass("active");
      document.querySelector("#chevIcon").style.display = "block";
      setShowResult(true);
      if (changeShowResult) {
        changeShowResult(true);
      }
      document.getElementById("txtGlobalSearchinput").focus();
    }
  };

  const getDescription = (item, searchText) => {
    let text = "";
    text +=
      item.WorkkardNumber != null && item.WorkkardNumber != ""
        ? HeaderUtil.highlightMatchingText(item.WorkkardNumber, searchText)
        : "";
    text +=
      item.WorkkardNameForClaimWk != null && item.WorkkardNameForClaimWk != ""
        ? `, ${HeaderUtil.highlightMatchingText(
          item.WorkkardNameForClaimWk,
          searchText
        )}`
        : "";
    text +=
      item.CarrierClaimNumber != null && item.CarrierClaimNumber != ""
        ? `, ${HeaderUtil.highlightMatchingText(
          item.CarrierClaimNumber,
          searchText
        )}`
        : "";
    text +=
      item.CaseNumber != null && item.CaseNumber != ""
        ? `, ${HeaderUtil.highlightMatchingText(item.CaseNumber, searchText)}`
        : "";
    return text;
  };

  const onClickGlobalSearchBackButton = () => {
    if (showResult) {
      if (!dialogueBox.flag) {
        setSearchText("");
      }

      setShowResult(false);
      document.getElementById(
        "txtGlobalSearchinput"
      ).style.display = "none";
      document.querySelector("#chevIcon").style.display =
        "none";
      $("#globalSearchdiv").removeClass("active");
    }
    else {
      if (dialogueBox.flag) {
        handleDialogueBoxClose();
      } else {
        document.getElementById(
          "txtGlobalSearchinput"
        ).style.display = "none";
        document.querySelector("#chevIcon").style.display =
          "none";
        $("#globalSearchdiv").removeClass("active");
      }
    }
  };

  const handleMobileSearchIconClickNotInLandscape = () => {
      if (!isEnterToSearchEnabled) return;
      if (searchText.trim().length > 0) {
        if (dialogueBox.flag) {
          saveSearchString({
            string: searchText,
          });
          let globaDiv = document.querySelector(
            "#globalSearchdivExpandedView"
          );
          globaDiv.querySelector("#txtGlobalSearchinput").blur();
          setShowResult(false);
          $("#globalSearchdivExpandedView").removeClass("active");
          changeShowResult(false, true);
        } else {
          if (searchText.trim().length > 0) {
            handleKeyDown({ isViewAll: true });
          }
        }
      }
  };

  const onClickGlobalSearchInputBox = () => {
      if (dialogueBox.flag)
        $("#globalSearchdivExpandedView").addClass("hover");
      else $("#globalSearchdiv").addClass("hover");
      if (
        !showResult &&
        (globalSearch.recentSearches.length > 0 ||
          searchText.trim().length > 0)
      ) {
        setShowResult(true);
        if (changeShowResult) {
          changeShowResult(true);
        }
        if (dialogueBox.flag) {
          //on click handle for class when dialogue box is open
          let globaDiv = document.querySelector(
            "#globalSearchdivExpandedView"
          );
          globaDiv.querySelector("#txtGlobalSearchinput").focus();
          globaDiv.classList.add("active");
        } else {
          $("#globalSearchdiv").addClass("active");
        }
      }
  };

  return (
    <div ref={searchRef}>
      <div className="search rowFlex alignMiddle">
        {!isLandscape &&  mobileAndTabletcheck() ? (
          <>
            <a role="button" tabIndex={0} onClick={handleMobileSearchIconClick}>
              <Icon name="search" className="icon searchIcon" />
            </a>
            <a role="button" tabIndex={0} id="chevIcon" onClick={onClickGlobalSearchBackButton}>
              <Icon name="chev" className="icon chevIcon ml__12" />
            </a>
          </>
        ) : (
          <a role="button" tabIndex={0}
            onClick={handleMobileSearchIconClickNotInLandscape}
          >
            <Icon name="search" className="icon searchIcon" />
          </a>
        )}
        <div className="formGroup mrNone">
          <input
            type="text"
            id="txtGlobalSearchinput"
            onPaste={handleGlobalSearch}
            placeholder="Jump to Workkard, Activity or anything"
            maxLength="50"
            onKeyDown={handleKeyDown}
            onInput={onChangeSearchText}
            onKeyUp={(e) => {
              if ((e.keyCode >= 37 && e.keyCode <= 40) || e.keyCode === 27 || (e.keyCode === 13 && !isEnterToSearchEnabled)) {
                return;
              } else if (e.keyCode == 8 && searchText.trim().length < 3) {
                resetSearchSuggestion();
              } else {
                handleGlobalSearch();
              }
            }}
            onClick={onClickGlobalSearchInputBox}
            value={searchText || recentSelectedItem}
            autoComplete="off"
          />
        </div>

        {(searchText.trim().length > 0 ||
          recentSelectedItem.trim().length > 0) && (
            <span
              onClick={() => {
                document.getElementById("txtGlobalSearchinput").focus();
                if (! mobileAndTabletcheck()) {
                  if (recentSelectedItem.trim().length > 0) {
                    setRecentSelectedItem("");
                    setUpDownPressed(false);
                    setSelectedItem(-1);
                    if (dialogueBox.flag) {
                      let globaDiv = document.querySelector(
                        "#globalSearchdivExpandedView"
                      );
                      globaDiv.querySelector("#txtGlobalSearchinput").focus();
                    } else
                      document.getElementById("txtGlobalSearchinput").focus();
                  } else {
                    if (globalSearch.recentSearches.length == 0) {
                      setShowResult(false);
                      if (dialogueBox.flag) {
                        $("#globalSearchdivExpandedView").removeClass("active");
                      } else {
                        $("#globalSearchdiv").removeClass("active");
                      }
                    }
                    setSearchText("");
                    setUpDownPressed(false);
                    setSelectedItem(-1);
                    if (dialogueBox.flag) {
                      let globaDiv = document.querySelector(
                        "#globalSearchdivExpandedView"
                      );
                      globaDiv
                        .querySelector("#txtGlobalSearchinput")
                        .focus();
                      if ( mobileAndTabletcheck()) {
                        $("#globalSearchdivExpandedView").addClass(
                          "active"
                        );
                      }
                    } else {
                      document
                        .getElementById("txtGlobalSearchinput")
                        .focus();
                    }
                  }
                } else {
                  setSearchText("");
                  setRecentSelectedItem("");
                }
                resetSearchSuggestion();
              }}
              id="clearSearchIcon"
              className="clearSearchIcon"
            >
              <Icon name="close" className="icon clearSearch" />
            </span>
          )}
      </div>

      {showResult && (
        <div className="searchResult rowFlex">
          {
            <>
              {searchText.trim().length == 0 ? (
                useModules().isModuleEnabled("top_bar_search.search_history") &&
                globalSearch.recentSearches &&
                globalSearch.recentSearches.length > 0 && (
                  <div
                    className="recentSearchResult colFlex"
                    style={
                      ! mobileAndTabletcheck()
                        ? { minHeight: "auto" }
                        : null
                    }
                  >
                    <div className="workkardIitems">
                      <header>
                        <div className="rowFlex alignMiddle">
                          <label>Recent Workkard Searches</label>
                        </div>
                        <a role="button" tabIndex={0}
                          onClick={(e) => {
                            removeRecentSearchItem(e, 0, true);
                          }}
                        >
                          clear all
                        </a>
                      </header>
                      <ul>
                        {globalSearch.recentSearches
                          .slice(0, 5)
                          .map((item, key) => {
                            const parsedItem = item.SearchData ? JSON.parse(item.SearchData) : item;
                            return (
                              <li
                                key={key}
                                id={item.WorkkardId}
                                className={`rowSpaceBetween ${selectedItem == key
                                    ? "onArrow"
                                    : ""
                                  }`}
                                onClick={() => {
                                  setShowResult(false);
                                  if (dialogueBox.flag) {
                                    $(
                                      "#globalSearchdivExpandedView"
                                    ).removeClass("active");
                                  } else {
                                    $("#globalSearchdiv").removeClass(
                                      "active"
                                    );
                                  }
                                  handleSuggestionClick(item.SearchData ? item.SearchData : item);
                                  window.location = `/getclmdetail?cId=${item.WorkkardId}`;
                                }}
                              >
                              <div className="colFlex">
                              {
                                  <label dangerouslySetInnerHTML={{__html : getDescription(parsedItem, "")}}>
                                  </label>

                              }
                              <label>{parsedItem.WkDescription || ""}</label>
                              </div>
                                <div className="selfStart">
                                  {/* <label className="status animated superFaster delay-5 public mr">{item.WorkkardStatus}</label> */}
                                  <div
                                    className="closeSearchList animated superFaster quickTooltip-top"
                                    data-quicktooltip="clear"
                                    style={
                                      selectedItem == key
                                        ? { display: "block" }
                                        : null
                                    }
                                    onClick={(e) => {
                                      removeRecentSearchItem(
                                        e,
                                        item.WorkkardId,
                                        false
                                      );
                                    }}
                                  >
                                    <span className="iconRipple">
                                      <Icon name="close" className="icon" />
                                    </span>
                                  </div>
                                </div>
                              </li>
                            );
                          })}
                      </ul>
                    </div>
                  </div>
                )
              ) : useModules().isModuleEnabled("top_bar_search.search_result") && (
                <div className="workkardSearchResult colFlex">
                  <div className="workkardIitems">
                    {searchText.trim().length >= 3 &&
                      globalSearch.suggestion.length > 0 && (
                        <header>
                          <div className="rowFlex alignMiddle">
                            <label>Workkards</label>
                          </div>
                         {
                          process.env.foo_expand_search === "true" &&
                          <a role="button" tabIndex={0}
                            onClick={() => {
                              if (dialogueBox.flag) {
                                saveSearchString({
                                  string: searchText,
                                });
                                let globaDiv = document.querySelector(
                                  "#globalSearchdivExpandedView"
                                );
                                globaDiv
                                  .querySelector("#txtGlobalSearchinput")
                                  .blur();
                                setShowResult(false);
                                if (! mobileAndTabletcheck()) {
                                  $(
                                    "#globalSearchdivExpandedView"
                                  ).removeClass("active");
                                }
                                changeShowResult(false, true);
                              } else {
                                handleKeyDown({ isViewAll: true });
                              }
                            }}
                          >
                            view all
                          </a>
                         }
                        </header>
                      )}
                    <ul>
                      {globalSearch.isLoading ? (
                        <LoaderComponent />
                      ) : globalSearch.suggestion &&
                        globalSearch.suggestion.length > 0 ? (
                        globalSearch.suggestion.map(
                          (item, key) => {
                            return (
                              <li
                                id={item.WorkkardId}
                                key={key}
                                className={`rowSpaceBetween ${selectedItem == key
                                    ? "onArrow"
                                    : ""
                                  }`}
                                onClick={() => {
                                  setShowResult(false);
                                  if (dialogueBox.flag) {
                                    $(
                                      "#globalSearchdivExpandedView"
                                    ).removeClass("active");
                                  } else {
                                    $("#globalSearchdiv").removeClass(
                                      "active"
                                    );
                                  }
                                  handleSuggestionClick(item);
                                  window.location = `/getclmdetail?cId=${item.WorkkardId}`;
                                }}
                              >
                                <div className="colFlex">
                                  {item.WorkkardNumber ||
                                    item.CarrierClaimNumber ||
                                    item.CaseNumber ||
                                    item.WorkkardNameForClaimWk ? (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: getDescription(
                                          item,
                                          searchText
                                        )
                                      }}
                                    ></div>
                                  ) : (
                                    ""
                                  )}
                                  <label>{item.WkDescription || ""}</label>
                                </div>
                              </li>
                            );
                          }
                        )
                      ) : searchText.trim().length > 0 &&
                        searchText.trim().length < 3 ? (
                        <div className="noDataFound">
                          Enter at least 3 characters to view the Workkard
                          results
                        </div>
                      ) : !dialogueBox.flag ? (
                        globalSearch.searchString &&
                        globalSearch.searchString.trim().length >
                        0 &&
                        globalSearch.suggestion.length < 1 && (
                          <div className="noDataFound">
                            No Workkard results found
                          </div>
                        )
                      ) : (
                        globalSearch.suggestion.length < 1 && (
                          <div className="noDataFound">
                            No Workkard results found
                          </div>
                        )
                      )}
                    </ul>
                  </div>
                </div>
              )}
            </>
          }
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  globalSearch: state.header.globalSearch,
  dialogueBox: state.dialogueBox,
  sessionContext: state.sessionContext,
});

const mapDispatchToProps = (dispatch) => ({
  getWorkkardSearchList: bindActionCreators(getWorkkardSearchList, dispatch),
  fetchUserRecentSearches: bindActionCreators(
    fetchUserRecentSearches,
    dispatch
  ),
  removeRecentSearchItem: bindActionCreators(removeRecentSearchItem, dispatch),
  resetSearchSuggestion: bindActionCreators(resetSearchSuggestion, dispatch),
  showDialogueBox: bindActionCreators(showDialogueBox, dispatch),
  hideDialogueBox: bindActionCreators(hideDialogueBox, dispatch),
  addglobalsearchusage: bindActionCreators(addglobalsearchusage, dispatch),
  resetGlobalSearch: bindActionCreators(resetGlobalSearch, dispatch),
  saveSearchString: bindActionCreators(saveSearchString, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalSearch);
